<template>
  <section>
    <article>
      <site-title :text="'About Jason'" />
      <img src="/static/image/jason-profile.jpg" alt="Jason Jun" class="avatar" ref="profileImg">
      <div ref="introCopy">
        <p>Hello, I'm Jason Jun, a UI designer and front-end developer based in Melbourne, Australia.</p>
        <p>I’ve been working in the digital design and development field since 2009, and moved from South Korea to Australia at the end of 2012 to study for a masters degree in Interactive and Digital Media at the University of Sydney.</p>
        <p>Upon finishing my degree, I moved to Melbourne, and have been working as a UI designer and front-end developer at a number of companies. Currently I'm working at Envato.</p>
        <p>Thanks for stopping by.</p>
      </div>
      <ul class="links" ref="links">
        <li><i>Email</i><u>uxd.jun@gmail.com</u></li>
        <li v-for="link in links" :key="link.type"><i>{{link.label}}</i><a :href="link.url" target="_blank">{{link.url}}</a></li>
      </ul>
    </article>
    <site-footer />
  </section>
</template>

<script>
import SiteTitle from '@/components/SiteTitle.vue'
import Footer from '@/components/Footer.vue'

import {TweenMax, Power3} from 'gsap'

export default {
  name: 'about',
  components: {
    'site-title': SiteTitle,
    'site-footer': Footer
  },
  data () {
    return {
      links: [
        {
          type: 'linkedin',
          label: 'LinkedIn',
          url: 'https://www.linkedin.com/in/jsonjun'
        },
        {
          type: 'codepen',
          label: 'CodePen',
          url: 'https://codepen.io/jsonjun'
        },
        {
          type: 'vimeo',
          label: 'Vimeo',
          url: 'https://vimeo.com/jsonjun'
        },
        {
          type: 'behance',
          label: 'Behance',
          url: 'https://behance.net/jsonjun'
        },
        {
          type: 'twitter',
          label: 'Twitter',
          url: 'https://twitter.com/jsonjun'
        },
        {
          type: 'blog',
          label: 'Blog',
          url: 'https://jasonjun.blog'
        }
      ]
    }
  },
  mounted () {
    TweenMax.from(this.$refs.profileImg, 1, {opacity: 0, y: 40, delay: 0.5, ease: Power3.easeOut})
    TweenMax.from(this.$refs.introCopy, 1, {opacity: 0, y: 40, delay: 0.8, ease: Power3.easeOut})
    TweenMax.from(this.$refs.links, 1, {opacity: 0, y: 40, delay: 1, ease: Power3.easeOut})
  }
}
</script>

<style lang="scss" scoped>
  section {
    min-height: 100vh;
    overflow: hidden;
    max-width: $size-max-width;
    margin: 0 auto;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  article {
    width: 100%;
    max-width: $size-max-width;
    margin: 0 auto;
  }

  .avatar {
    display: block;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin: 100px 0;

    @include device(mobile) {
      width: 120px;
      height: 120px;
      margin: 50px 0;
    }
  }

  p {
    max-width: 560px;
    margin: 1.5rem 0;
  }

  .links {
    margin: 80px 0;

    & li {
      margin-bottom: 1rem;
      font-size: 0.8rem;
      font-weight: 500;

      @include device(mobile) {
        margin-bottom: 1.5rem;
      }

      & i {
        display: inline-block;
        font-style: normal;
        min-width: 120px;
        font-weight: 400;
      }

      & u {
        text-decoration: none;
      }

      & a {
        opacity: 0.5;
        color: $color-black;
        border-bottom: 1px solid $color-black;
        transition: opacity 0.1s linear;

        &:hover {
          opacity: 1;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/About.vue